// Level choices for a class or rule whose season belongs to `programType` ('LK' | 'SI').
//
// A class's real level is NOT constrained by its season's program: a franchise can put an SI class
// in an LK season or vice versa (LKFD-201, PAT-0002), and the server accepts the other program's
// level (with a reason). So BOTH programs' levels are offered -- the season's program first, in
// catalog order, then the other program's, each marked `isOtherProgram` so the caller can label it.
//
// 'LK Other' / 'SI Other' (is_rule_targetable = 0) are offered across programs too: an SI refund
// or clinic class in an LK season belongs under SI Other, not LK Other (LKFD-226). Callers that
// must exclude non-targetable levels altogether (the rule editor) filter them before calling.
//
// With no known program (null, or a mixed group) every level is offered as-is.
export function levelOptionsForProgram(levels, programType) {
  const all = levels || [];
  if (programType !== 'LK' && programType !== 'SI') {
    return all.map((l) => ({ ...l, isOtherProgram: false }));
  }
  const own = all.filter((l) => l.program_type === programType)
    .map((l) => ({ ...l, isOtherProgram: false }));
  const other = all.filter((l) => l.program_type !== programType)
    .map((l) => ({ ...l, isOtherProgram: true }));
  return [...own, ...other];
}

// Menu text for a level option: the other program's levels carry their program, so a choice that
// differs from the season's program is visible before it is saved.
export function levelOptionLabel(level) {
  return level.isOtherProgram
    ? `${level.program_type} · ${level.canonical_level_name}`
    : level.canonical_level_name;
}
